export default "__VITE_ASSET__CwmOuTXH__"